<template>
  <div class="h5content" id="scrollContent">
    <div class="returnItem" v-for="(row, index) in list" :key="index">
      <div
        class="toptitle P-Cursor row flex-center"
        :class="!row.isOpen ? 'nb' : ''"
        @click="openCLoseFollow(row)"
      >
        <i class="iconfont icon-sanjiao" :class="row.isOpen ? 'open' : ''"></i>
        <div class="flex-1">回访计划</div>
        <div class="typeTag" :class="getStatusClass(row)">
          {{ row.statusStr }}
        </div>
      </div>

      <div class="info" v-if="row.isOpen">
        <div class="infoitem row flex-center">
          <div class="left">计划时间:</div>
          <div class="flex-1 righttext">
            {{ row.plannedTime }}
          </div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">回访人:</div>
          <div class="flex-1 righttext">{{ row.executorName }}</div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">回访类型:</div>
          <div class="flex-1 righttext">{{ row.returnVisitType }}</div>
        </div>
        <div class="infoitem row">
          <div class="left">回访内容:</div>
          <div class="flex-1 righttext">{{ row.content }}</div>
        </div>
      </div>
      <!---->
      <div class="info info-bottom" v-if="shouldShowInfo(row)">
        <div class="info-title">回访执行</div>
        <div class="infoitem row flex-center">
          <div class="left">执行时间:</div>
          <div class="flex-1 righttext">
            {{ row.executionTime }}
          </div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">回访人:</div>
          <div class="flex-1 righttext">{{ row.executorName }}</div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">沟通方式:</div>
          <div class="flex-1 righttext">{{ row.connectMethod }}</div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">回访项目:</div>
          <div class="flex-1 righttext">{{ row.itemName }}</div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">跟进说明:</div>
          <div class="flex-1 righttext">{{ row.traceDesc }}</div>
        </div>
        <div class="infoitem row flex-center">
          <div class="left">满意度:</div>
          <div class="flex-1 righttext">{{ row.satisfaction }}</div>
        </div>
      </div>
    </div>
    <EmptyImgh5 v-if="list.length == 0"></EmptyImgh5>
  </div>
</template>

<script>
import func from "@/util/func.js";
import tableListMixin from "@/mixin/tableList.js";
import { userStore } from "@/store/user";

import { returnVisitPage } from "@/api/patient.js";
import { loadingStore } from "@/store/loading.js";

export default {
  name: "visitRecords",
  mixins: [tableListMixin],
  props: [],
  components: {},
  data: function () {
    return {};
  },
  setup() {
    let loadingTip = loadingStore();
    return {
      loadingTip,
    };
  },
  mounted: function () {
    let that = this;
    that.getList();
  },
  methods: {
    getList() {
      let that = this;
      if (that.isloading || that.isFinish) {
        return;
      }
      const pages = that.pages;
      const aloginStoreuth = userStore();
      let reqdata = {
        queryDateType: 2,
        current: pages.current,
        size: pages.pageSize,
        cusId: aloginStoreuth.cusId,
        corpId: aloginStoreuth.corpId,
        isCrossClinic: true,
      };

      that.isloading = true;
      that.loadingTip.showLoading();
      returnVisitPage(reqdata)
        .then((res) => {
          that.loadingTip.hideLoading();
          const { records, total } = res.data.data;

          // 将 isOpen 设置为 false，并添加到列表中
          const updatedRecords = records.map((item) => ({
            ...item,
            isOpen: true,
          }));
          that.list.push(...updatedRecords);

          that.pages.current++;
          that.pages.total = total;

          // 如果已加载的数量大于等于总数，设置 isFinish 为 true
          that.isFinish = that.list.length >= total;
          that.isloading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openCLoseFollow(row) {
      row.isOpen = !row.isOpen;
    },
    getStatusClass(row) {
      if (row.status == "0") {
        return "todo";
      } else if (row.status == "2") {
        return "failed";
      } else if (row.status == "3") {
        return "gary";
      } else {
        return "success";
      }
    },
    shouldShowInfo(row) {
      if (row.status != 0 && row.status != 3 && row.isOpen) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.returnItem {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  margin-bottom: 15px;
}

.toptitle {
  font-size: 0.292rem;
  padding: 0.167rem 0.313rem;
  border-bottom: 1px solid #ededed;
  background: #f7f7f7;
  text-align: left;

  &.nb {
    border-bottom: none;
  }

  .icon-sanjiao {
    color: #999999;
    margin-right: 0.104rem;
    position: relative;
    transition: all 0.3s;
    transform: rotate(-90deg);

    &.open {
      transform: rotate(0deg);
    }
  }

  .typeTag {
    font-size: 0.25rem;
    padding: 0.083rem 0.125rem;
    border-radius: 0.042rem;

    &.todo {
      background: #fff7e8;
      color: #faad14;
    }

    &.failed {
      background: #ffeded;
      color: #ff4d4f;
    }

    &.success {
      background: rgb(227, 251, 215);
      color: rgb(82, 196, 26);
    }

    &.gary {
      background: #ededed;
      /* 或者使用具体的灰色色值，比如 #808080 */
      color: #666;
      /* 同样可以使用具体的灰色色值 */
    }
  }
}

.info {
  padding: 0 0.25rem;
  padding-bottom: 0.208rem;

  .info-title {
    text-align: left;
    margin: 10px 0;
  }

  &.info-bottom {
    position: relative;
    padding-bottom: 0.25rem;

    &::before {
      content: "";
      width: 100%;
      height: 1px;
      left: 0;
      top: 0;
      background: #e6e6e6;
      display: inline-block;
    }
  }

  .infoitem {
    text-align: left;
    font-size: 0.292rem;
    margin-top: 0.25rem;

    .left {
      width: 1.792rem;
      color: #666;
      text-align: left;
    }

    .righttext {
      font-size: 0.292rem;
      color: #333;
      text-align: left;
    }
  }
}
</style>
